// src/services/content/store/modules/customer-requests.js
export class CustomerRequestsHandler {
  constructor(store) {
    this.store = store;
  }

  /**
   * Get Customer Requests content by locale
   * @param {string} locale Locale to get content for
   * @returns {Object|null} Content or null if not found
   */
  getContent(locale = 'en') {
    const localeContent = this.store.state.data.customerRequests?.[locale];
    if (localeContent) return localeContent;
    
    // Fall back to English if different locale was requested
    if (locale !== 'en') {
      return this.store.state.data.customerRequests?.['en'] || null;
    }
    
    return null;
  }
}